import React from "react";
import { Center, Image, Wrap } from "@chakra-ui/react";
import { getMediaSrc } from "./ProductMediaContext";

const ProductMediaThumbnails = ({
    images = [],
    activeIndex = 0,
    onSelect,
    layout = "wrap",
    containerStyle,
    thumbnailsStyle,
    containerRef,
}) => {
    const content = images.map((img, index) => (
        <Center
            key={`${img?.id || img?.url || "thumb"}-${index}`}
            data-thumbnail-index={index}
            style={{ width: 48, height: 32, padding: 4, cursor: "pointer", flexShrink: 0, ...thumbnailsStyle }}
            borderWidth={index === activeIndex ? 1 : 0}
            borderColor="red.300"
            onClick={() => onSelect?.(index)}
        >
            <Image style={{ width: 48, height: 32, padding: 2 }} src={img.sm_url || getMediaSrc(img)} fit="contain" />
        </Center>
    ));

    if (layout === "scroll") {
        return (
            <div ref={containerRef} style={{ display: "flex", alignItems: "center", gap: 4, minWidth: "max-content", height: "100%", ...containerStyle }}>
                {content}
            </div>
        );
    }

    return (
        <Wrap style={containerStyle} wrap={true} gap={4}>
            {content}
        </Wrap>
    );
};

export default ProductMediaThumbnails;